module.exports = __webpack_public_path__ + "img/header_bg.7c0b16ba.png";